import React, { useEffect, useRef } from "react"
import queryString from "query-string"
import Cookies from "js-cookie"
import IframeResizer from "iframe-resizer-react"
import { StyledIFrame } from "./partials"
export interface StudentLoginCmpProps {
  programGrouping?: string
  programOptions?: Array<string>
  loaded?: boolean
  method?: string
  is_dark?: boolean
  student_app_3?: boolean
}
// Student App
export const StudentLoginCmp: React.FC<StudentLoginCmpProps> = ({
  programGrouping,
  programOptions,
  loaded,
  is_dark,
  method = 'signup',
  student_app_3
}) => {
  const iframeRef = useRef()
  useEffect(() => {
    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S
      const program = queryParams.prog
      if (program) {
        const date = new Date()
        date.setMinutes(date.getMinutes() + 1)

        Cookies.set("hult_program", program, {
          domain: ".hult.edu",
          path: "/",
          expires: date,
          sameSite: "None",
          secure: true,
        })
      }
      if (contactId) {
        const date = new Date()
        date.setMinutes(date.getMinutes() + 5)
        Cookies.set("hult_sid", contactId, {
          domain: ".hult.edu",
          path: "/",
          expires: date,
          sameSite: "None",
          secure: true,
        })
      }
      if (programGrouping) {
        const date = new Date()
        date.setMinutes(date.getMinutes() + 1)
        Cookies.set("hult_az_program", programGrouping, {
          // domain: ".hult.edu",
          domain: ".hult.edu",
          path: "/",
          expires: date,
          sameSite: "None",
          secure: true,
        })
      }
      else if (programOptions) {
        const date = new Date()
        date.setMinutes(date.getMinutes() + 1)
        Cookies.set("hult_az_program", JSON.stringify(programOptions), {
          // domain: ".hult.edu",
          domain: ".hult.edu",
          path: "/",
          expires: date,
          sameSite: "None",
          secure: true,
        })
      }

      if (method && method === 'login') {
        const date = new Date()
        date.setSeconds(date.getSeconds() + 15)
        Cookies.set("hult_az_method", method, {
          domain: ".hult.edu",
          path: "/",
          expires: date,
          sameSite: "None",
          secure: true,
        })
      }
      window.addEventListener(
        "message",
        function (e) {

          if (e.origin.includes(".hult.edu")) {
            switch (e.data) {
              case "signUp":
                window.location.href =
                  process.env.GATSBY_STUDENT_APP_REDIRECT_URL || "#"
                break
              case "signUp3":
                window.location.href =
                  process.env.GATSBY_STUDENT_APP_3_REDIRECT_URL || "#"
                break
              case "redirectToSitecore":
                window.location.href =
                  process.env.GATSBY_SITECORE_APP_REDIRECT_URL || "#"
                break
              default:
                window.location.href = "#"
            }
          }
        },
        false
      )
      if (iframeRef && iframeRef.current && is_dark) {
        iframeRef.current.children[0].contentWindow.postMessage("is_dark", "https://login.hult.edu/")
      }
    }
  }, [])
  return (
    <StyledIFrame loaded={loaded} ref={iframeRef}>
      <IframeResizer
        bodyBackground={is_dark ? "dark" : "light"}
        heightCalculationMethod="lowestElement"
        minHeight={300}
        data-is-dark={is_dark}
        src={student_app_3 ? process.env.GATSBY_STUDENT_APP_3_IFRAME_URL : process.env.GATSBY_STUDENT_APP_IFRAME_URL}
        resizeFrom="parent"
        checkOrigin={false}
        style={{ width: "1px", minWidth: "100%" }}
      />
    </StyledIFrame>
  )
}